import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAcademicYearPayload, IInitialStateAcademicYear } from "../types";
import { GetAcademicYears } from "./thunk";

const initialState: IInitialStateAcademicYear = {
    academicYearData: [],
    selectedYearIDs: [],
    isLoadingYear: false,
    yearsRestoreData: [],
    isViewYearsRestore: false,
    filteredYear: [],
    yearsDate: [],
};

const academicYearSlice = createSlice({
    name: "academicYear",
    initialState,
    reducers: {
        setAcademicYear: (state, action: PayloadAction<{ data: IAcademicYearPayload[]; defaultLanguage: string }>) => {
            const { data, defaultLanguage } = action.payload;

            state.academicYearData = data;
            state.filteredYear = state.academicYearData.flatMap(data =>
                data.translations
                    .filter(elem => elem.slug === defaultLanguage && elem.name)
                    .map(elem => ({
                        id: data.id,
                        name: elem.name as string,
                    }))
            );
        },

        generateYearsRange: state => {
            const startYear = 2000;
            const endYear = new Date().getFullYear() + 30;
            const yearsForward = [];

            for (let i = startYear; i <= endYear; i++) {
                yearsForward.push(i);
            }

            state.yearsDate = yearsForward;
        },

        deletedYear: (state, action: PayloadAction<number>) => {
            state.academicYearData = state.academicYearData.filter(elem => elem.id !== action.payload);
        },
        updateYear: (state, action: PayloadAction<IAcademicYearPayload>) => {
            const updateData = action.payload;

            state.academicYearData = state.academicYearData.map(elem => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setIsViewYearsRestore: state => {
            state.isViewYearsRestore = !state.isViewYearsRestore;
        },

        setYearsRestoreData: (state, action) => {
            state.yearsRestoreData = action.payload;
        },
        deletedRestoreYears: (state, action) => {
            state.yearsRestoreData = state.yearsRestoreData.filter(elem => elem.id !== action.payload);
        },
        setSelectedYearIDs: (state, action) => {
            state.selectedYearIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetAcademicYears.pending, state => {
                state.isLoadingYear = true;
            })
            .addCase(GetAcademicYears.fulfilled, state => {
                state.isLoadingYear = false;
            })
            .addCase(GetAcademicYears.rejected, state => {
                state.isLoadingYear = false;
            });
    },
});

export const {
    setAcademicYear,
    deletedYear,
    updateYear,
    setIsViewYearsRestore,
    setYearsRestoreData,
    deletedRestoreYears,
    setSelectedYearIDs,
    generateYearsRange,
} = academicYearSlice.actions;

export default academicYearSlice;
